import { Route } from 'react-router';
import { RouteKeyGenerator } from '../RouteKeyGenerator';
import ROW2Route from './ROW2Route';

const ROW2Routes = (): React.ReactElement => {
    return (
        <>
            <Route path="PlanningSystem" element={<ROW2Route key={RouteKeyGenerator.key} title="PlanningSystem" url="ROW2/#/Agenda" />} />
            <Route path="PlacerList" element={<ROW2Route key={RouteKeyGenerator.key} title="PlacerList" url="ROW2/#/PlacerList" />} />
            <Route path="PlacerlistForPatient" element={<ROW2Route key={RouteKeyGenerator.key} title="PlacerList" url="ROW2/#/PlacerList" />} />
            <Route path="GeneralSettings" element={<ROW2Route key={RouteKeyGenerator.key} title="GeneralSettings" url="ROW2/#/GeneralSettings" />} />
            <Route path="exportFormats" element={<ROW2Route key={RouteKeyGenerator.key} title="exportFormats" url="ROW2/#/ExportFormats" />} />
            <Route path="Appointment" element={<ROW2Route key={RouteKeyGenerator.key} title="Appointment" url="ROW2/#/Agenda" />} />
        </>
    );
};

export default ROW2Routes;
